import React, { useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { Section } from './Shared';
const faqs = [{
  q: '¿Sirve si recién empiezo con el Reiki?',
  a: 'Absolutamente. El MEGA PACK fue diseñado con dos terapeutas en mente: el que ya tiene experiencia y quiere estructurar lo que hace, y el que está comenzando y quiere instalar hábitos profesionales desde el inicio. El sistema se adapta a cualquier nivel porque parte de la mentalidad, no de la técnica avanzada.'
}, {
  q: '¿Cómo recibo el material?',
  a: 'Inmediatamente después de tu compra recibís un email con el link de descarga de todos los archivos PDF. Acceso en menos de 5 minutos.'
}, {
  q: '¿Necesito imprimir todo el material?',
  a: 'No es necesario. Todo está diseñado para usarse en tablet, computadora o celular. Si preferís tener los checklists y fichas impresos para usar en el consultorio, el formato está optimizado para impresión A4.'
}, {
  q: '¿Qué lo diferencia de un manual de Reiki tradicional?',
  a: 'Los manuales de Reiki enseñan técnica. El MEGA PACK te da un sistema operativo completo para ejercer como profesional. No es un libro de estudio: es una herramienta de trabajo que usás antes, durante y después de cada sesión.'
}, {
  q: '¿Tiene garantía real?',
  a: 'Sí. 7 días de garantía sin preguntas. Si no es lo que esperabas, te devolvemos el 100% del dinero. Así de simple.'
}, {
  q: '¿Puedo compartirlo con otros terapeutas?',
  a: 'El material es de uso personal e intransferible. Está protegido por derechos de autor. Si querés recomendarlo a un colega, podés compartir el link de compra.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const reduceMotion = useReducedMotion();
  return <Section className="max-w-3xl" data-id="element-80" data-mp="iy4oqquu5wzy">
      <div className="mb-10 text-center" data-id="element-81" data-mp="iz67lhi3fns8"><h2 className="font-display text-3xl font-bold text-brand-ink md:text-4xl" data-id="element-82" data-mp="mzq7gsu1x5i2">LO QUE MÁS NOS PREGUNTAN</h2></div>
      <div className="space-y-3" data-id="element-83" data-mp="2pn54z4acwudc">
        {faqs.map((faq, index) => {
        const isOpen = index === openIndex;
        return <article key={faq.q} className="glass-panel overflow-hidden rounded-2xl" data-id="element-84" data-mp="2kuc10imppq2b" data-mpi={index}>
              <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-6 px-5 py-5 text-left text-sm font-semibold text-brand-ink focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-[-4px] focus-visible:outline-brand-purple md:px-6 md:text-base" data-id="element-85" data-mp="2fxlq09prlknr">
                <span data-id="element-86" data-mp="2yms9hyydugam">{faq.q}</span>
                <ChevronDownIcon className={`h-5 w-5 shrink-0 text-brand-purple transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} data-id="element-87" data-mp="2ylqmcw43e3cj" />
              </button>
              <AnimatePresence initial={false} data-id="element-88" data-mp="1n8er39meet1z">
                {isOpen && <motion.div initial={reduceMotion ? false : {
              opacity: 0,
              height: 0
            }} animate={{
              opacity: 1,
              height: 'auto'
            }} exit={reduceMotion ? undefined : {
              opacity: 0,
              height: 0
            }} transition={{
              duration: 0.2
            }} data-id="element-89" data-mp="1j6t58yrvz4fn">
                    <p className="border-t border-brand-purple/15 bg-brand-paper/50 px-5 py-5 text-sm leading-relaxed text-brand-text md:px-6 md:text-base" data-id="element-90" data-mp="2pc97xc0ep5s">{faq.a}</p>
                  </motion.div>}
              </AnimatePresence>
            </article>;
      })}
      </div>
    </Section>;
}